export const translations = {
  heroTitle1: { en: "Why choose", ar: "لماذا تختار", nl: "Waarom kiezen voor" },
  heroTitleBrand: { en: "Halal Correct?", ar: "حلال كوريكت؟", nl: "Halal Correct?" },
  heroSubtitle: {
    en: "Your trusted halal certification partner.",
    ar: "شريكك الموثوق لشهادات الحلال.",
    nl: "Uw betrouwbare partner voor halalcertificering.",
  },
  trustPillClients: {
    en: "Trusted by 100+ clients across Europe",
    ar: "موثوق من قبل أكثر من 100 عميل في أوروبا",
    nl: "Vertrouwd door 100+ klanten in heel Europa",
  },
  trustPillIso: {
    en: "ISO 9001:2015 accredited",
    ar: "معتمد ISO 9001:2015",
    nl: "ISO 9001:2015 geaccrediteerd",
  },
  applyNow: { en: "Apply Now", ar: "تقدم الآن", nl: "Nu aanvragen" },
  learnMore: { en: "Learn More", ar: "اعرف أكثر", nl: "Meer informatie" },
  watchVideo: {
    en: "Watch how certification works",
    ar: "شاهد كيف تعمل عملية الشهادة",
    nl: "Bekijk hoe certificering werkt",
  },
  trustStatClients: {
  en: "Clients certified across Europe",
  ar: "عميل معتمد في جميع أنحاء أوروبا",
  nl: "Klanten gecertificeerd in heel Europa",
},
trustStatYears: {
  en: "Years of halal certification experience",
  ar: "سنوات من الخبرة في شهادات الحلال",
  nl: "Jaar ervaring in halalcertificering",
},
trustStatBodies: {
  en: "International accreditation bodies",
  ar: "هيئات اعتماد دولية",
  nl: "Internationale accreditatie-instanties",
},
trustAccreditationIbfr: {
  en: "IBFR Supervised",
  ar: "تحت إشراف IBFR",
  nl: "Onder toezicht van IBFR",
},
csrPrinciplesTitle: {
  en: "Corporate social responsibility principles",
  ar: "مبادئ المسؤولية الاجتماعية للشركات",
  nl: "Principes voor maatschappelijk verantwoord ondernemen",
},

csrPrinciplesSubtitle: {
  en: "Applied to every activity and decision we make.",
  ar: "نطبقها في كل نشاط وقرار نتخذه.",
  nl: "Toegepast op elke activiteit en beslissing die we nemen.",
},

accountabilityTitle: {
  en: "Accountability",
  ar: "المساءلة",
  nl: "Verantwoordelijkheid",
},

accountabilityText: {
  en: "We own our decisions and their outcomes.",
  ar: "نتحمل مسؤولية قراراتنا ونتائجها.",
  nl: "Wij nemen verantwoordelijkheid voor onze beslissingen en de resultaten ervan.",
},

transparencyTitle: {
  en: "Transparency",
  ar: "الشفافية",
  nl: "Transparantie",
},

transparencyText: {
  en: "Open processes, no hidden steps.",
  ar: "عمليات واضحة، دون خطوات خفية.",
  nl: "Open processen, zonder verborgen stappen.",
},

ethicalBehaviorTitle: {
  en: "Ethical behavior",
  ar: "السلوك الأخلاقي",
  nl: "Ethisch gedrag",
},

ethicalBehaviorText: {
  en: "Doing right, not just what's easy.",
  ar: "فعل الصواب، وليس فقط ما هو سهل.",
  nl: "Het juiste doen, niet alleen wat gemakkelijk is.",
},

stakeholderRespectTitle: {
  en: "Stakeholder respect",
  ar: "احترام أصحاب المصلحة",
  nl: "Respect voor belanghebbenden",
},

stakeholderRespectText: {
  en: "Every voice in the process matters.",
  ar: "كل صوت في العملية له أهمية.",
  nl: "Elke stem in het proces is belangrijk.",
},

legalComplianceTitle: {
  en: "Legal compliance",
  ar: "الامتثال القانوني",
  nl: "Naleving van de wet",
},

legalComplianceText: {
  en: "Full respect for laws and regulations.",
  ar: "الالتزام الكامل بالقوانين واللوائح.",
  nl: "Volledig respect voor wet- en regelgeving.",
},

globalStandardsTitle: {
  en: "Global standards",
  ar: "المعايير العالمية",
  nl: "Wereldwijde normen",
},

globalStandardsText: {
  en: "Aligned with international best practice.",
  ar: "متوافقون مع أفضل الممارسات الدولية.",
  nl: "In overeenstemming met internationale best practices.",
},

humanRightsTitle: {
  en: "Human rights",
  ar: "حقوق الإنسان",
  nl: "Mensenrechten",
},

humanRightsText: {
  en: "Respected in everything we do.",
  ar: "نحترمها في كل ما نقوم به.",
  nl: "Gerpecteerd in alles wat we doen.",
},
principlesTabTitle: {
  en: "The principles behind our work",
  ar: "المبادئ التي توجه عملنا",
  nl: "De principes achter ons werk",
},

principlesTabSubtitle: {
  en: "Halal Correct Certification is guided by four core principles in everything we do.",
  ar: "تسترشد هلال كوريكت للشهادات بأربعة مبادئ أساسية في كل ما نقوم به.",
  nl: "Halal Correct Certification wordt in alles wat we doet geleid door vier kernprincipes.",
},

consciousIntegrityLabel: {
  en: "Conscious integrity",
  ar: "النزاهة الواعية",
  nl: "Bewuste integriteit",
},

consciousIntegritySummary: {
  en: "Expertise, reliability, and honesty guide how we work with every client.",
  ar: "الخبرة والموثوقية والصدق توجه طريقة عملنا مع كل عميل.",
  nl: "Deskundigheid, betrouwbaarheid en eerlijkheid bepalen hoe we met elke klant werken.",
},

consciousIntegrityText: {
  en: "Our approach toward consumers is built on expertise, reliability, and an honest working environment. We translate these values into a 'conscious integrity' that guides day-to-day practice — alongside a shared awareness that everyone in the organization is responsible for their actions.",
  ar: "يعتمد نهجنا تجاه المستهلكين على الخبرة والموثوقية وبيئة العمل الصادقة. ونترجم هذه القيم إلى «نزاهة واعية» توجه ممارساتنا اليومية، إلى جانب وعي مشترك بأن كل فرد في المنظمة مسؤول عن أفعاله.",
  nl: "Onze benadering van consumenten is gebaseerd op deskundigheid, betrouwbaarheid en een eerlijke werkomgeving. We vertalen deze waarden naar een 'bewuste integriteit' die onze dagelijkse praktijk stuurt, samen met het gedeelde besef dat iedereen binnen de organisatie verantwoordelijk is voor zijn of haar handelen.",
},

objectiveApproachLabel: {
  en: "Objective approach",
  ar: "النهج الموضوعي",
  nl: "Objectieve aanpak",
},

objectiveApproachSummary: {
  en: "Open information leads to clear, transparent, and fair decisions.",
  ar: "تؤدي المعلومات المفتوحة إلى قرارات واضحة وشفافة وعادلة.",
  nl: "Open informatie leidt tot duidelijke, transparante en eerlijke beslissingen.",
},

objectiveApproachText: {
  en: "Getting relevant information out in the open results in a transparent decision-making process. This means asking the right questions, listening carefully, and asking more — every time. Agreements that follow from this communication create shared obligations: both parties are responsible and accountable for the outcome.",
  ar: "إن إتاحة المعلومات ذات الصلة بشكل واضح تؤدي إلى عملية شفافة لاتخاذ القرارات. وهذا يعني طرح الأسئلة الصحيحة، والاستماع بعناية، وطرح المزيد من الأسئلة في كل مرة. والاتفاقيات الناتجة عن هذا التواصل تخلق التزامات مشتركة، حيث يتحمل الطرفان مسؤولية ومساءلة النتائج.",
  nl: "Het open beschikbaar maken van relevante informatie leidt tot een transparant besluitvormingsproces. Dit betekent de juiste vragen stellen, zorgvuldig luisteren en telkens verder doorvragen. Afspraken die uit deze communicatie voortkomen, creëren gedeelde verplichtingen: beide partijen zijn verantwoordelijk en aansprakelijk voor het resultaat.",
},

trustProfessionalismLabel: {
  en: "Trust in professionalism",
  ar: "الثقة في المهنية",
  nl: "Vertrouwen in professionaliteit",
},

trustProfessionalismSummary: {
  en: "Every judgment is backed by evidence, not just opinion.",
  ar: "كل حكم يستند إلى الأدلة، وليس إلى الرأي فقط.",
  nl: "Elk oordeel wordt onderbouwd door bewijs, niet alleen door een mening.",
},

trustProfessionalismText: {
  en: "Respecting professionalism is a top priority — it results in hard information based on evidence. An expert's opinion matters, but their substantiation is what counts. Our audits and inspections require deep expertise, close collaboration, and professionalism that is constantly maintained and strengthened.",
  ar: "احترام المهنية يمثل أولوية قصوى، فهو يؤدي إلى معلومات موثوقة تستند إلى الأدلة. رأي الخبير مهم، لكن ما يهم هو إثباته ودعمه بالأدلة. وتتطلب عمليات التدقيق والتفتيش لدينا خبرة عميقة وتعاونًا وثيقًا ومهنية يتم الحفاظ عليها وتعزيزها باستمرار.",
  nl: "Het respecteren van professionaliteit is een topprioriteit en leidt tot betrouwbare informatie op basis van bewijs. De mening van een expert is belangrijk, maar de onderbouwing ervan telt. Onze audits en inspecties vereisen diepgaande expertise, nauwe samenwerking en professionaliteit die voortdurend wordt onderhouden en versterkt.",
},

continuousLearningLabel: {
  en: "Continuous learning",
  ar: "التعلم المستمر",
  nl: "Continu leren",
},

continuousLearningSummary: {
  en: "We improve constantly, because our environment never stands still.",
  ar: "نحن نتحسن باستمرار لأن بيئتنا لا تتوقف عن التغير.",
  nl: "We verbeteren voortdurend, omdat onze omgeving nooit stilstaat.",
},

continuousLearningText: {
  en: "Improvement is an essential part of our process — every experience shows that what we do can be done more effectively. Learning is the natural extension of improvement, and it's necessary because our environment is in constant flux, requiring us to keep adjusting.",
  ar: "التحسين جزء أساسي من عمليتنا، فكل تجربة تُظهر أن ما نقوم به يمكن تنفيذه بشكل أكثر فعالية. والتعلم هو الامتداد الطبيعي للتحسين، وهو ضروري لأن بيئتنا في تغير مستمر، مما يتطلب منا مواصلة التكيف.",
  nl: "Verbetering is een essentieel onderdeel van ons proces — elke ervaring laat zien dat wat we doen nog effectiever kan. Leren is het natuurlijke verlengstuk van verbetering en is noodzakelijk omdat onze omgeving voortdurend verandert, waardoor we ons steeds moeten blijven aanpassen.",
},

showLess: {
  en: "Show less",
  ar: "عرض أقل",
  nl: "Minder weergeven",
},

readMore: {
  en: "Read more",
  ar: "اقرأ المزيد",
  nl: "Lees meer",
},
halalProcedureTitle: {
  en: "Halal procedure:",
  ar: "إجراءات الحلال:",
  nl: "Halalprocedure:",
},

halalProcedureSubtitle: {
  en: "",
  ar: "",
  nl: "",
},

knowYourHalalHeadline: {
  en: "Know your Halal",
  ar: "اعرف حلالك",
  nl: "Ken uw halal",
},

knowYourHalalSummary: {
  en: "Helping Muslims worldwide identify products that meet halal requirements.",
  ar: "مساعدة المسلمين حول العالم على تحديد المنتجات التي تستوفي متطلبات الحلال.",
  nl: "Moslims wereldwijd helpen producten te identificeren die aan de halalvereisten voldoen.",
},

knowYourHalalText: {
  en: "Muslims around the world find difficulties to know how their food is produced and where it comes from. That is why, Halal Certification helps Muslims around the world to identify these products by establishing a system that checks if the products meet their halal requirements.",
  ar: "يواجه المسلمون حول العالم صعوبة في معرفة كيفية إنتاج طعامهم ومصدره. ولهذا السبب، تساعد شهادة الحلال المسلمين حول العالم على تحديد هذه المنتجات من خلال إنشاء نظام يتحقق من استيفائها لمتطلبات الحلال.",
  nl: "Moslims over de hele wereld vinden het moeilijk om te weten hoe hun voedsel wordt geproduceerd en waar het vandaan komt. Daarom helpt halalcertificering moslims wereldwijd om deze producten te identificeren door een systeem op te zetten dat controleert of de producten aan hun halalvereisten voldoen.",
},

consumerConfidenceHeadline: {
  en: "Consumer confidence",
  ar: "ثقة المستهلك",
  nl: "Consumentenvertrouwen",
},

consumerConfidenceSummary: {
  en: "Making it easy for consumers to know a product is halal-compliant.",
  ar: "تسهيل معرفة المستهلكين بأن المنتج متوافق مع متطلبات الحلال.",
  nl: "Het consumenten gemakkelijk maken om te weten of een product halal is.",
},

consumerConfidenceText: {
  en: "Food certification helps consumers make an easy decision to purchase the products. Halal certification states that the product is allowed to be consumed based on Islamic rules.",
  ar: "تساعد شهادة المنتجات الغذائية المستهلكين على اتخاذ قرار سهل بشأن شراء المنتجات. وتؤكد شهادة الحلال أن المنتج مسموح باستهلاكه وفقًا للقواعد الإسلامية.",
  nl: "Voedselcertificering helpt consumenten om gemakkelijk te beslissen of ze producten willen kopen. Halalcertificering bevestigt dat het product volgens islamitische regels mag worden geconsumeerd.",
},

applicationAuditHeadline: {
  en: "Application & audit",
  ar: "التقديم والتدقيق",
  nl: "Aanvraag & audit",
},

applicationAuditSummary: {
  en: "A structured audit program tailored to your organization's scope.",
  ar: "برنامج تدقيق منظم ومخصص لنطاق مؤسستك.",
  nl: "Een gestructureerd auditprogramma afgestemd op de reikwijdte van uw organisatie.",
},

applicationAuditText: {
  en: "An application system for a Halal Certificate has been established by Halal Correct Certification. The completion of the audit program is based on the size, scope, products, processes, level of the management system and the results of previous audits of the organization.",
  ar: "وضعت هلال كوريكت للشهادات نظامًا للتقديم للحصول على شهادة الحلال. ويعتمد تنفيذ برنامج التدقيق على حجم المؤسسة ونطاقها ومنتجاتها وعملياتها ومستوى نظام الإدارة ونتائج عمليات التدقيق السابقة للمؤسسة.",
  nl: "Halal Correct Certification heeft een aanvraagsysteem voor een halalcertificaat opgezet. De uitvoering van het auditprogramma is gebaseerd op de omvang, reikwijdte, producten, processen, het niveau van het managementsysteem en de resultaten van eerdere audits van de organisatie.",
},
halalProducerTitle: {
  en: "Are you a Halal producer or supplier?",
  ar: "هل أنت منتج أو مورد حلال؟",
  nl: "Bent u een halalproducent of -leverancier?",
},

halalProducerSubtitle: {
  en: "Get certified for international halal markets.",
  ar: "احصل على شهادة للوصول إلى الأسواق الحلال الدولية.",
  nl: "Laat uw producten certificeren voor internationale halalmarkten.",
},
accreditationPartnershipTitle: {
  en: "Accreditation and partnership:",
  ar: "الاعتماد والشراكة:",
  nl: "Accreditatie en partnerschap:",
},
latestNews: {
  en: "Latest News",
  ar: "آخر الأخبار",
  nl: "Laatste nieuws",
},

blogPageDescription: {
  en: "Updates, statements, and insights from Halal Correct Certification.",
  ar: "آخر التحديثات والبيانات والرؤى من هلال كوريكت للشهادات.",
  nl: "Updates, verklaringen en inzichten van Halal Correct Certification.",
},

searchBlogPosts: {
  en: "Search blog posts",
  ar: "البحث في المقالات",
  nl: "Zoek in blogberichten",
},

previousPage: {
  en: "Previous page",
  ar: "الصفحة السابقة",
  nl: "Vorige pagina",
},

nextPage: {
  en: "Next page",
  ar: "الصفحة التالية",
  nl: "Volgende pagina",
},

page: {
  en: "Page",
  ar: "صفحة",
  nl: "Pagina",
},

of: {
  en: "of",
  ar: "من",
  nl: "van",
},

moreNews: {
  en: "More News",
  ar: "المزيد من الأخبار",
  nl: "Meer nieuws",
},
satisfiedCustomersTitle: {
  en: "Some of our satisfied customers:",
  ar: "بعض عملائنا الراضين:",
  nl: "Enkele van onze tevreden klanten:",
},

satisfiedCustomersAlt: {
  en: "Satisfied customers",
  ar: "عملاء راضون",
  nl: "Tevreden klanten",
},
visitUsTitle: {
  en: "Visit us",
  ar: "تفضل بزيارتنا",
  nl: "Bezoek ons",
},

visitUsDescription: {
  en: "Have a question about certification? Reach out — we're happy to help.",
  ar: "هل لديك سؤال حول الشهادة؟ تواصل معنا — يسعدنا مساعدتك.",
  nl: "Heeft u een vraag over certificering? Neem contact met ons op — we helpen u graag.",
},

addressLabel: {
  en: "Address",
  ar: "العنوان",
  nl: "Adres",
},

hoursLabel: {
  en: "Hours",
  ar: "ساعات العمل",
  nl: "Openingstijden",
},

halalCorrectLocation: {
  en: "Halal Correct location",
  ar: "موقع هلال كوريكت",
  nl: "Locatie van Halal Correct",
},
footerLogoAlt: {
  en: "Halal Correct logo",
  ar: "شعار هلال كوريكت",
  nl: "Halal Correct-logo",
},

footerDescription: {
  en: "Halal inspection and Halal certification for producers and suppliers across Europe.",
  ar: "التفتيش على الحلال وشهادات الحلال للمنتجين والموردين في جميع أنحاء أوروبا.",
  nl: "Halal-inspectie en halalcertificering voor producenten en leveranciers in heel Europa.",
},

footerUsefulLinks: {
  en: "Useful links",
  ar: "روابط مفيدة",
  nl: "Handige links",
},

footerContactUs: {
  en: "Contact us",
  ar: "اتصل بنا",
  nl: "Neem contact met ons op",
},

footerScope: {
  en: "Scope",
  ar: "النطاق",
  nl: "Werkterrein",
},

footerScopeDescription: {
  en: "Halal inspection and Halal certification",
  ar: "التفتيش على الحلال وشهادات الحلال",
  nl: "Halal-inspectie en halalcertificering",
},

footerHome: {
  en: "Home",
  ar: "الرئيسية",
  nl: "Home",
},

footerWhoAreWe: {
  en: "Who are we?",
  ar: "من نحن؟",
  nl: "Wie zijn wij?",
},

footerCompanyStructure: {
  en: "Company structure",
  ar: "هيكل الشركة",
  nl: "Bedrijfsstructuur",
},

footerOurServices: {
  en: "Our services",
  ar: "خدماتنا",
  nl: "Onze diensten",
},

footerCertificationBenefits: {
  en: "Benefits of our certification",
  ar: "فوائد شهادتنا",
  nl: "Voordelen van onze certificering",
},

footerMeaningHalal: {
  en: "Meaning of halal",
  ar: "معنى الحلال",
  nl: "Betekenis van halal",
},

footerApply: {
  en: "Apply",
  ar: "تقدم بطلب",
  nl: "Aanvragen",
},

footerRequestInformation: {
  en: "Request for information",
  ar: "طلب معلومات",
  nl: "Informatie aanvragen",
},

footerFeedback: {
  en: "Feedback",
  ar: "ملاحظات",
  nl: "Feedback",
},

footerComplaint: {
  en: "Complaint",
  ar: "شكوى",
  nl: "Klacht",
},

footerCertificateCheck: {
  en: "Halal certificate check",
  ar: "التحقق من شهادة الحلال",
  nl: "Halal-certificaat controleren",
},

footerLocations: {
  en: "Locations",
  ar: "المواقع",
  nl: "Locaties",
},

footerCopyright: {
  en: "Copyright",
  ar: "حقوق النشر",
  nl: "Copyright",
},

footerAllRightsReserved: {
  en: "All Rights Reserved",
  ar: "جميع الحقوق محفوظة",
  nl: "Alle rechten voorbehouden",
},
  navHome: {
    en: "Home",
    ar: "الرئيسية",
    nl: "Home",
  },

  navAbout: {
    en: "About Us",
    ar: "من نحن",
    nl: "Over ons",
  },

  navCertification: {
    en: "Certification",
    ar: "الشهادات",
    nl: "Certificering",
  },

  navPolicies: {
    en: "Policies",
    ar: "السياسات",
    nl: "Beleid",
  },

  navContact: {
    en: "Contact",
    ar: "اتصل بنا",
    nl: "Contact",
  },

  navBlog: {
    en: "Blog",
    ar: "المدونة",
    nl: "Blog",
  },

  navWhoAreWe: {
    en: "Who are we?",
    ar: "من نحن؟",
    nl: "Wie zijn wij?",
  },

  navCompanyStructure: {
    en: "Company structure",
    ar: "هيكل الشركة",
    nl: "Bedrijfsstructuur",
  },

  navVisionMissionValues: {
    en: "Vision, mission and core values",
    ar: "الرؤية والرسالة والقيم الأساسية",
    nl: "Visie, missie en kernwaarden",
  },

  navInternationalApproval: {
    en: "International approval",
    ar: "الاعتماد الدولي",
    nl: "Internationale goedkeuring",
  },

  navHalalMeaning: {
    en: "What does halal mean?",
    ar: "ماذا يعني الحلال؟",
    nl: "Wat betekent halal?",
  },

  navLocations: {
    en: "Locations",
    ar: "المواقع",
    nl: "Locaties",
  },

  navHalalCertificationProcess: {
    en: "Halal Certification Process",
    ar: "عملية شهادة الحلال",
    nl: "Halalcertificeringsproces",
  },

  navProductCategories: {
    en: "Product categories",
    ar: "فئات المنتجات",
    nl: "Productcategorieën",
  },

  navOurServices: {
    en: "Our services",
    ar: "خدماتنا",
    nl: "Onze diensten",
  },

  navAuditingTraining: {
    en: "Auditing and training",
    ar: "التدقيق والتدريب",
    nl: "Auditing en training",
  },

  navCertificationBenefits: {
    en: "Benefits of our certification",
    ar: "فوائد شهادتنا",
    nl: "Voordelen van onze certificering",
  },

  navCertificationTerms: {
    en: "Certification Terms",
    ar: "شروط الشهادة",
    nl: "Certificeringsvoorwaarden",
  },

  navBpjphRecognition: {
    en: "BPJPH recognition",
    ar: "اعتراف BPJPH",
    nl: "BPJPH-erkenning",
  },

  navHalalGuarantee: {
    en: "Halal guarantee",
    ar: "ضمان الحلال",
    nl: "Halalgarantie",
  },

  navIntegrityPolicy: {
    en: "Integrity policy",
    ar: "سياسة النزاهة",
    nl: "Integriteitsbeleid",
  },

  navHandlingAppeals: {
    en: "Handling appeals and complaints",
    ar: "معالجة الطعون والشكاوى",
    nl: "Behandeling van beroepen en klachten",
  },

  navFeeRegulation: {
    en: "Fee Regulation",
    ar: "لائحة الرسوم",
    nl: "Kostenregeling",
  },

  navConfidentialityImpartiality: {
    en: "Confidentiality And Impartiality",
    ar: "السرية والحياد",
    nl: "Vertrouwelijkheid en onpartijdigheid",
  },

  navNonDiscriminatory: {
    en: "Non-discriminatory condition",
    ar: "شرط عدم التمييز",
    nl: "Non-discriminatoire voorwaarde",
  },

  navRequestInformation: {
    en: "Request for information",
    ar: "طلب معلومات",
    nl: "Informatie aanvragen",
  },

  navFeedback: {
    en: "Feedback",
    ar: "ملاحظات",
    nl: "Feedback",
  },

  navComplaint: {
    en: "Complaint",
    ar: "شكوى",
    nl: "Klacht",
  },

  navCertificateCheck: {
    en: "Halal certificate check",
    ar: "التحقق من شهادة الحلال",
    nl: "Halal-certificaat controleren",
  },

  navSaudiExportForm: {
    en: "Saudi Arabia Export Form",
    ar: "نموذج التصدير إلى المملكة العربية السعودية",
    nl: "Exportformulier voor Saoedi-Arabië",
  },
}